<template>
  <div class="icon-section" :class="icons.length < 10 ? 'justify-content' : ''" v-bind:style="{width: iconsLength * 140 + 'px'}" v-if="render">
<!--  <div class="icon-section" v-if="render">-->
    <AppIconXjh v-for="(item,index) in icons" :key="item.id"
                :item="item" :grid="grid" :cell="cell" :order="index"
                :user="user"></AppIconXjh>
  </div>
</template>

<script>
import AppIconXjh from "@/views/AppIconXjh.vue";

export default {
  name: 'AppGridXjh',
  components: {
    AppIconXjh
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      iconsLength: 12,
      justifyContent: "left",
      grid: {//网格行列个数
        row: 0,
        col: 0
      },
      cell: {//每个单元格大小
        height: 120,
        width: 120
      },
      row: 0,
      render: true,
    }
  },
  created() {
    let w = document.body.clientWidth
    let h = this.getHeight()
    this.grid.row = Math.ceil(h / this.cell.height) - 1
    this.grid.col = Math.ceil(w / this.cell.width)
  },
  computed: {
    icons() {
      let icons = []
      this.$store.state.core.applications.forEach(item => {
          icons.push(item)
      })
      if (icons.length >= 7){
        this.iconsLength = icons.length + 1
      }
      return icons;
    }
  },
  mounted() {
    const that = this
    window.addEventListener("resize", function () {
      let h = that.getHeight()
      that.row = Math.ceil(h / that.cell.height) - 1
    })
  },
  methods: {
    getHeight() {
      let h = document.body.clientHeight
      let minHeight = this.$store.state.wallpaper.minHeight;
      h = h < minHeight ? minHeight : h
      h = h - this.$store.state.core.taskHeight
      return h
    }
  },
  watch: {
    row(val) {
      if (val <= 0) {
        val = 1
      }
      this.grid.row = val
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
  }
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 1050px) {
  .icon-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    //margin-top: 50px;
    //padding: 0px 368px;
    margin: 30px auto;
    //top: 50px;
    left: 0;
  }

  .justify-content{
    justify-content: center;
  }
}
.icon-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  //margin-top: 50px;
  //padding: 0px 368px;
  margin: 30px auto;
  //top: 50px;
  left: 0;
}

.justify-content{
  justify-content: center;
}
</style>
